import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';
import { UgcImageGalleryListingComponent } from '../ugc-image-gallery-listing.component';
import { NUgcImageGallery } from '../ugc-image-gallery.namespace';
import { UgcImageGalleryCmsComponent } from './ugc-image-gallery-cms.component';
@Component({
    selector: 'ugc-image-gallery-listing-cms',
    template: '<ugc-image-gallery-listing [content]="component"></ugc-image-gallery-listing>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [UgcImageGalleryListingComponent]
})
@ICmsComponent<UgcImageGalleryListingCmsComponent>({
    id: 'ugc-image-gallery-listing',
    name: 'User Generated Content Image Gallery Listing Layout',
    tags: ['ugc', 'gallery', 'listing'],
    fields: [...NUgcImageGallery.FIELDS.slice(0, 2), <NICmsContentField.IField>{
            key: 'text',
            type: NICmsContentField.EFieldType.text,
            title: 'Text',
        }, ...NUgcImageGallery.FIELDS.slice(3), NUgcImageGallery.UGC_CATEGORY_FIELD,
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.number,
            title: 'Initial Steps loaded',
            key: 'initialStepsVisible',
            description: 'Steps showing up at page load'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.number,
            title: 'Step Size',
            key: 'infScrollStep',
            description: 'Number of items loaded per infinite scroll step.'
        },]
})
export class UgcImageGalleryListingCmsComponent extends UgcImageGalleryCmsComponent {
    @ICmsContent({
        type: 'component'
    })
    override component?: NUgcImageGallery.IListingData;
}
